var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	
$(document).ready(function() {
	
	$("#frmSupport").validate();

	if(siteId == 1){
		$(".phone").mask("(999) 999-9999");
	}else{
		$(".phone").mask("999999999999999");
	}
	$("#gsm_code").intlTelInput({
// 				preferredCountries: ["${countryCode}"],
		preferredCountries: [CommonPayment.countryCode],
		americaMode: false
	});

	$("#gsm_code").focusout(function(){
		var isTR = $("[name=gsm_code]").val().includes("+90");
		if(isTR){
			$("[name=gsm]").mask("(999) 999-9999");
		}else{
			$("[name=gsm]").mask("999999999999999");
		}
	});

	$(".email").validate();
	$(".accordion-usage , .accordion-faq").accordion({
		autoHeight : false,
		collapsible : true,
		active : 52
	});
	$(".cc-chat").click(function() {
		try {
			LC_API.open_chat_window();
		} catch (e) {
			alert(e);
			return false;
		}
		return false;
	});
	$( ".contact-forms" ).tabs();
	
});

var recaptchaFeedBack;
var recaptchaSupport;
function onloadCallbackContact(){
	recaptchaFeedBack = grecaptcha.render('recaptchaFeedBack', {
        'sitekey' : captchasitekey
      });
	recaptchaSupport = grecaptcha.render('recaptchaSupport', {
        'sitekey' : captchasitekey
      });
}

function sendSupport(){
	$("#frmSupport").validate();
	if(!$("#frmSupport").valid()) return false;
	if(grecaptcha.getResponse(recaptchaSupport).length == 0){
		alert(FmtMessage.getMessage('js.check.googlecaptcha.warn'));
		return false;
	}else {
		$("#frmSupport").submit();
		grecaptcha.reset(recaptchaSupport)
	}
}
		
$("#frmSupport").submit(function(e) {
    e.preventDefault();
    $.ajax({
    	type:'POST',
        async:false,
        url: '/a/supportWithForm',
        data: $("#frmSupport").serialize(),
        success: function(data) {
        	$("#response").show();
			$(window).scrollTop(0);
        	if(data){
        	    resetSupportForm();
        		$('#btnSupport').attr("disabled", true);
        		$("#failure").hide();
        		$("#success").show();
				$('html, body').animate({scrollTop:$('.inner-page-title').offset().top}, 'slow');
				$("#frmSupport").validate().cancelSubmit = true;
        	}else{
        		$("#success").hide();	
        		$("#failure").show();
        	}
         },
        error: function() {
            //alert('Error occured');
        }
    });       
});

function sendFeedBack(){
	$("#frmfeedback").validate();
	if(!$("#frmfeedback").valid()) return false;
	if(grecaptcha.getResponse(recaptchaFeedBack).length == 0){
		alert(FmtMessage.getMessage('js.check.googlecaptcha.warn'));
		return false;
	}else {
		$("#frmfeedback").submit();
		grecaptcha.reset(recaptchaFeedBack)
	}
}
$("#frmfeedback").submit(function(e) {
    e.preventDefault();
    $.ajax({
    	type:'POST',
        async:false,
        url: '/a/feedbackForm',
        data: $("#frmfeedback").serialize(),
        success: function(data) {
        	$("#responseFeedback").show();
			$(window).scrollTop(0);
        	if(data){
        		$('#btnfeedback').attr("disabled", true);
        		$("#failureFeedback").hide();
        		$("#successFeedback").show();
        	}else{
        		$("#successFeedback").hide();	
        		$("#failureFeedback").show();
        	}
         },
        error: function() {
            //alert('Error occured');
        }
    });       
});



function reloadCaptcha() {
	$('#captcha').attr('src', '/a/captcha?' + new Date().getTime());
}

function resetSupportForm() {
	$("#frmSupport").val
	$("[name=supportType]").val("");
	$("[name=referenceNo]").val("");
	$("[name=name]").val("");
	$("[name=surname]").val("");
	$("[name=email]").val("");
	$("[name=gsm]").val("");
	$("[name=subject]").val("");
	$("[name=content]").val("");
}